import Countable from 'countable'

import { ARIA_CONTROLS } from './consts'

const OUTPUT_ID = 'word-count'
const WORD_LIMIT = 50

/**
 * TODO There should be some kind of constraint (e.g. the input has to be uncle
 *      or grand-uncle of the strong)
 *      ...in fact what happes if in a page we need to have two of those ?
 */
export default (container = 'body') => {
  const inputElement = document.querySelector(
    `${container} [data-clientside-hook~="word-count"]`
  )
  const outputElement = document.querySelector(
    `${container} [data-clientside-hook~="word-count-output"] strong`
  )
  let currentCount = WORD_LIMIT

  if (inputElement === null || outputElement == null) {
    return
  }

  const onInput = counter => {
    const newCount = Math.max(0, WORD_LIMIT - counter.words)
    if (currentCount !== newCount) {
      currentCount = newCount
      outputElement.textContent = currentCount
    }
  }

  outputElement.id = OUTPUT_ID
  outputElement.setAttribute('aria-live', 'polite')
  inputElement.setAttribute(ARIA_CONTROLS, OUTPUT_ID)
  Countable.off(inputElement)
  Countable.on(inputElement, onInput)
}
